function placeholderFor(input) {
    const placeholder = input.nextElementSibling;

    return placeholder?.classList.contains('placeholder') ? placeholder : null;
}

function markAsValid(input) {
    const placeholder = placeholderFor(input);

    if (placeholder && input.value.trim() !== '') {
        placeholder.classList.add('valid');
    }
}

export function markFilledInputs(root = document) {
    root.querySelectorAll('.cont_ipt input').forEach(markAsValid);
}

export function initializeInputValidation(root = document) {
    root.querySelectorAll('.cont_ipt input').forEach((input) => {
        const placeholder = placeholderFor(input);

        if (! placeholder) {
            return;
        }

        input.addEventListener('click', () => {
            placeholder.classList.add('valid');

            if (input.value.trim() !== '' && placeholder.nextElementSibling) {
                placeholder.nextElementSibling.classList.add('valid');
            }
        });
    });
}

export function registerInputValidation(root = document, eventTarget = window) {
    initializeInputValidation(root);
    eventTarget.addEventListener('load', () => markFilledInputs(root));
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    registerInputValidation();
}
